//  全部的mutations命名在这里
//  命名规则
//  全部大写
//  模块名称 + 下划线 + 函数名称

// 改变左侧导航栏状态
export const LAYOUT_CHANGE = 'LAYOUT_CHANGE'

// 改变用户信息
export const USER_CHANGE = 'USER_CHANGE'

// app构建时显示loading
export const APP_LOADING_CHANGE = 'APP_LOADING_CHANGE'

// app设备状态
export const APP_NAVIGATOR_CHANGE = 'APP_NAVIGATOR_CHANGE'
